import React, { useEffect, useMemo } from "react";
import { Logo } from "../assets/icons/Icons";
import { useUserData } from "../lib/contexts/UserContext";
import HospitalCard from "../components/HospitalCard";
import Loader from "../components/Loader";
import { useHospDocData } from "../lib/contexts/HospitalDoctorContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { HiArrowLeft } from "react-icons/hi2";

const ChooseCarouselDoctors = () => {
  const { userData } = useUserData();
  const { hospitalID, allDoctorsData, doctors, setDoctors } = useHospDocData();
  const navigate = useNavigate();

  useEffect(() => {
    const activeDoctors = (allDoctorsData || []).filter(
      (doctor) => (doctor as any).is_active === true
    );
    setDoctors(activeDoctors);
  }, [allDoctorsData, setDoctors]);

  const sortedDoctors = useMemo(() => {
    if (!allDoctorsData) return [];
    // Create a shallow copy to sort safely
    return [...allDoctorsData].sort((a, b) => {
      const a_active = (a as any).is_active === true ? 1 : 0;
      const b_active = (b as any).is_active === true ? 1 : 0;
      // Sorts active (1) before inactive (0)
      return b_active - a_active;
    });
  }, [allDoctorsData]);

  return (
    <>
     {doctors && ( 
        <div className="fixed bottom-0 left-0 right-0 w-full bg-gradient-to-t from-white to-transparent h-32 flex items-center justify-center z-10">
          <button
            className="bg-[#0F3CBE] text-white shadow-md rounded-lg hover:opacity-70 px-5 py-2 z-10"
            onClick={() => {
              if (doctors.length === 0) {
                toast.error("Please select at least 1 doctor for the slideshow.");
              } else {
                try{
                  localStorage.setItem('recentColumnViewDoctors', JSON.stringify(doctors));
                  navigate("/" + hospitalID + "/carousel-view"); 
                } catch(error){
                  console.error("Failed to save doctors to localstorage:", error);
                  toast.error("Could not save session");
                }
              }
            }}
          >
            Next -{">"}
          </button>
        </div>
      )}
      <div className=" flex justify-start bg-white shadow-md cursor-pointer 
             hover:bg-blue-500 hover:text-white transition-all duration-200 p-2 h-10 w-10 m-4 items-center rounded-full"
            onClick={() => navigate("/" + hospitalID)}
      >
        <HiArrowLeft
          className="w-6 h-6 text-blue-500" 
          style={{ color: 'inherit' }} // This ensures the 'hover:text-white' from parent works
        />
      </div>
     <div className="flex flex-col w-full justify-center items-center pt-6 pb-40">
        <Logo />
        <p className="font-semibold text-dark text-lg md:text-2xl lg:text-3xl mt-12 mb-5">
          Choose doctors (Slideshow)
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  xl:grid-cols-3 gap-7 mb-16">
          {/* Create constant */}
          {sortedDoctors?.map((doctor) => {
            // Filter out hidden doctors to calculate correct selection numbers
            const visibleSelectedDoctors = (doctors || []).filter(
              (d) => !(d as any).hide_from_tv
            );
            const selectionIndex = visibleSelectedDoctors.findIndex(
              (d) => d.doctor_id === doctor.doctor_id
            );
            const selectionNumber = selectionIndex > -1 ? selectionIndex + 1 : undefined;
            return(
            <HospitalCard
              key={doctor.doctor_id}
              logo={doctor.profile_picture}
              name={doctor.full_name}
              qualification={doctor.qualification}
              specialization={doctor.specialization}
              is_active={(doctor as any).is_active}
              selectionNumber={selectionNumber}
              docCount={"none"}
              gender={doctor.gender}
              hide_from_tv={doctor.hide_from_tv}
              show_name_prefix={doctor.show_name_prefix !== false}
              selected={doctors?.some(d => d.doctor_id === doctor.doctor_id) ?? false}
              handlePress={() => {
                console.log(doctor.full_name);
                setDoctors((prevDoctors = []) => {

                const isDoctorPresent = prevDoctors.some(
                 (d) => d.doctor_id === doctor.doctor_id
                );

             if (!isDoctorPresent) {
                return [...prevDoctors, doctor];
            }
                return prevDoctors.filter((e)=>e.doctor_id!==doctor.doctor_id);
                });
                }}
            />
            )})}
        </div>

     {userData === undefined && <Loader />}
        </div>
    </>
  );
};

export default ChooseCarouselDoctors;